import axios from "axios";
import promise from "promise";
import {
  logout,
  validateTokenExpiry,
} from "@carrier-sce-sharedpackages/auth-module";
import appConfig from "./carrierAuthApi/appConfig";
import { baseUrl } from "./baseUrl";

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

function ensureAuthModuleStorageMetadata() {
  if (!localStorage.getItem("uiUrl") && appConfig.uiUrl) {
    localStorage.setItem("uiUrl", appConfig.uiUrl);
  }
  if (!localStorage.getItem("apiUrl") && appConfig.apiUrl) {
    localStorage.setItem("apiUrl", appConfig.apiUrl);
  }
}

axiosInstance.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem("msal.idtoken");
    if (accessToken) {
      ensureAuthModuleStorageMetadata();
      validateTokenExpiry();
    }

    //Add the validation token to the request headers
    if (accessToken) {
      if (config.method !== "OPTIONS") {
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }
    return config;
  },
  function (error) {
    console.log(error);
    return promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    //If there was a 401 error (unauthorized) then attempt to log in again
    if (error && error.response && error.response.status === 401) {
      if (localStorage.getItem("msal.idtoken")) {
        ensureAuthModuleStorageMetadata();
        logout(appConfig, true);
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
